import { useLayoutEffect } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { isDesktop } from "utils/isDesktop";

export default function useNormalizeScroll() {
  useLayoutEffect(() => {
    !isDesktop &&
      ScrollTrigger.normalizeScroll({
        allowNestedScroll: true,
        // lockAxis: false,
        // type: "touch,wheel,pointer", // now the page will be drag-scrollable on desktop because "pointer" is in the list
      });

    const rootEl = document.getElementById("root");
    rootEl?.classList.add("loaded");

    ScrollTrigger.sort();
    ScrollTrigger.refresh();
  }, []);
}
